<template>
  <div>
    <Mainlayout></Mainlayout>

    <CCard>
      <CCol sm="12" class="justify-content-center mt-3">
        <CContainer>
          <CCol>
            <CRow>
              <!-- Quiz Details -->
              <h4 class="text-left mt-3 bold col-10">
                Quiz Summary
                <!-- <img src="../assets/img/quiz.png" width="120px" /> -->
              </h4>
            </CRow>
            <CRow>
              <!-- me -- share -->
              <CCard
                class="col-12 bg-gradient-turqouise box-shadow"
                style="border-color: #80b3ff; border-radius: 15px"
              >
                <CRow class="mt-1 mb-1">
                  <CCol class="col-2">
                    <span v-if="qSummary.studentProfilePhoto != null">
                    <img
                      :src="getPic(qSummary)"
                      class="ml-2 mt-1 box-shadow"
                      width="60px"
                      style="border-radius: 50%; border: 1px solid #eee"
                    />
                    </span>
                    <span v-else>
                      <img
                      src="../assets/img/user.png"
                      class="ml-2 mt-1 box-shadow"
                      width="60px"
                      style="border-radius: 50%; border: 1px solid #eee"
                    />
                    </span>
                  </CCol>
                  <CCol class="col-10 text-left mt-2">
                    <p class="ml-4 custom-font text-white">
                      <strong>{{ qSummary.studentName }}</strong>
                      <br />
                      <label class="custom-font">{{
                        qSummary.gradeName
                      }}</label>
                    </p>
                  </CCol>
                </CRow>
              </CCard>

              <!-- accuracy -->
              <CCard
                style="border-color: #80b3ff; border-radius: 15px"
                class="col-12 box-shadow"
              >
                <div class="col-12">
                  <div class="text-center mt-2">
                    <vue-ellipse-progress
                      :data="circles"
                      :progress="qSummary.studentScore.toFixed(2)"
                      :angle="-0"
                      :color="GetColor(qSummary.studentScore.toFixed(2))"
                      :colorFill="ColorFillGradient"
                      emptyColor="#009688"
                      :emptyColorFill="emptyColorFillGradient"
                      :size="120"
                      :thickness="9"
                      emptyThickness="5%"
                      lineMode="in 7"
                      :legend="true"
                      :legendValue="qSummary.studentScore.toFixed(2)"
                      legendClass="legend-custom-style"
                      dash="strict 50 0.9"
                      animation="reverse 800 400"
                      :noData="false"
                      :loading="false"
                      fontColor="green"
                      :half="true"
                      :gap="5"
                      fontSize="1.2rem"
                    >
                      <span slot="legend-value">%</span>
                    </vue-ellipse-progress>

                     <label class="custom-font text-success col-12"
                    ><div class="row">
                      <b class="col-10 text-left"> <span> Correct Answer</span></b>
                      <b class="col-2 text-right">
                       <strong> <CIcon name="cil-check-circle"
                      /></strong></b>
                    </div>
                    <CProgress
                      color="success"
                      :value="qSummary.correctAns"
                      :max="qSummary.questionCount"
                      show-percentage
                      animated
                      class="mt-2"
                    ></CProgress>
                  </label>

                  <label class="custom-font mt-3 text-danger col-12"
                    ><div class="row">
                      <b class="col-10 text-left"> <span>Incorrect Answer</span> </b>
                      <b class="col-2 text-right">
                       <strong> <CIcon name="cil-x-circle"
                      /></strong></b>
                    </div>
                    <CProgress
                      color="danger"
                      :value="qSummary.wrongAns"
                      :max="qSummary.questionCount"
                      show-percentage
                      animated
                      class="mt-2"
                    ></CProgress
                  ></label>

                  <label class="custom-font mt-4 float-left"
                    ><b>Quiz Duration </b></label
                  >
                  <span class="text-center custom-font float-right mt-4"
                    ><b>{{ qSummary.studentTimerStirng }}</b></span
                  >
                  </div>
                </div>
                 
              </CCard>
            </CRow>

          </CCol>

          <CButton
            color="success"
            class="custom-btn"
            size="lg"
            block
            :disabled="isDisabled"
            @click="GotoPageQuestionDescription(qSummary.quizId)"
            >Retake</CButton
          >

          <!-- <CButton
            color="success"
            class="custom-btn"
            size="lg"
            block
            :disabled="isDisabled"
            @click="GotoPageListQuestion()"
            >Check Answer</CButton
          > -->

          <CButton
            color="success"
            class="custom-btn"
            size="lg"
            block
            :disabled="isDisabled"
            @click="GoToPageLeaderBoard()"
            >View Leaderboard</CButton
          >

          <CButton
            color="success"
            class="custom-btn"
            size="lg"
            block
            :disabled="isDisabled"
            @click="GoToPageStudentExam()"
            >Back to Exam List</CButton
          >

          <br />
          <br />
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import VueEllipseProgress from "vue-ellipse-progress";
//import VueProgressBar from 'vue-progressbar';
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.use(VueEllipseProgress);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },

  data: function () {
    return {
      qSummary: {},
      max: 100,
    };
  },

  computed: {},


  async mounted() {
    this.GetQuizStudentHistoryDetailByQuiz();
    //this.GetQuizPreview();
    if (localStorage.getItem('reloaded')) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        localStorage.removeItem('reloaded');
    } else {
        // Set a flag so that we know not to reload the page twice.
        localStorage.setItem('reloaded', '1');
        location.reload();
    }
  },
  methods: {
    //Get quiz summary
    async GetQuizStudentHistoryDetailByQuiz() {
      this.$API
        .get(
          this.$QuizStudentHistoryDetailByQuiz +
          "?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId +
          "&quizScoreId=" +
          this.$route.query.quizScoreId,
          {
          withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
          this.qSummary = response.data;
          console.log(this.qSummary);
          this.GetColor(this.qSummary.studentScore);
          
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(qSummary){
      return "https://pickiddo.com" + qSummary.studentProfilePhoto;
    },
    GotoPageQuestionDescription(quizId) {
      this.$router.push(
        "/QuizStudentDescription?quizId=" +
          quizId +
          "&studentId=" +
          this.$route.query.studentId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GotoPageListQuestion() {
      this.$router.push(
        "/QuizStudentListQuestion?quizScoreId=" +
          this.$route.query.quizScoreId + 
          "&studentId=" +
          this.$route.query.studentId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GoToPageStudentExam() {
      this.$router.push(
        "/QuizStudentExam?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToPageLeaderBoard() {
      this.$router.push(
        "/QuizStudentLeaderBoard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId +
          "&quizScoreId=" +
          this.$route.query.quizScoreId
      );
    },
    GetColor: function () {
      console.log("e" + this.qSummary.studentScore);
      if (this.qSummary.studentScore <= 39) {
        return "red";
      } else if (this.qSummary.studentScore <= 79) {
        return "yellow";
      } else if (this.qSummary.studentScore >= 80) {
        return "green";
      }
      return "";
    },
  },
};
</script>



